import { useTranslation } from "react-i18next";
import { useTheme } from "../../../shared/contexts/ThemeContext";
import i18n from "../../../shared/i18n/i18n";
import { AUTH_CSS } from "../authStyles";

/**
 * Marco de las pantallas públicas de acceso (invitación, recuperar y
 * restablecer contraseña): la misma barra, fondo y tarjeta que el login, en
 * una sola columna.
 */
export default function AuthShell({ children }) {
  const { t } = useTranslation();
  const { theme, toggleTheme } = useTheme();

  function handleToggleLang() {
    const next = i18n.language === "es" ? "en" : "es";
    i18n.changeLanguage(next);
    localStorage.setItem("lang", next);
  }

  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800;900&display=swap"
        rel="stylesheet"
      />
      <style>{AUTH_CSS}</style>

      <nav className="lp-nav">
        <img src="/LOGO.png" alt="Corvana" />
        <span className="lp-nav-word">
          <span className="cor">COR</span>
          <span className="vian">VANA</span>
        </span>
        <div className="lp-nav-util">
          <button className="lp-nav-btn" onClick={handleToggleLang} title={t("header.cambiarIdioma")}>
            {i18n.language === "es" ? "EN" : "ES"}
          </button>
          <button className="lp-nav-btn" onClick={toggleTheme}
            title={theme === "light" ? t("header.temaOscuro") : t("header.temaClaro")}>
            <i className={`fa-solid ${theme === "light" ? "fa-moon" : "fa-sun"}`} />
          </button>
        </div>
      </nav>

      <div className="lp-bg">
        <div className="lp-card lp-card-single">
          <div className="lp-panel-right">
            {children}
            <div className="lp-form-foot">
              <strong>Corvana</strong> © {new Date().getFullYear()}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

/** Campo de contraseña con botón de mostrar/ocultar, con las clases del login. */
export function PasswordField({ id, label, value, onChange, error, disabled, autoComplete = "new-password", show, onToggle, hint }) {
  return (
    <div className="lp-field">
      <label className="lp-field-label" htmlFor={id}>{label}</label>
      <div className="lp-field-wrap">
        <input
          id={id}
          type={show ? "text" : "password"}
          className={`lp-input${error ? " lp-input-err" : ""}`}
          placeholder="• • • • • • • •"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          autoComplete={autoComplete}
          style={{ paddingRight: 36 }}
        />
        <button type="button" className="lp-eye" tabIndex={-1} onClick={onToggle}>
          <i className={`fa-solid ${show ? "fa-eye-slash" : "fa-eye"}`} />
        </button>
      </div>
      {hint && !error && <div className="lp-hint">{hint}</div>}
      {error && <FieldError msg={error} />}
    </div>
  );
}

export function TextField({ id, label, value, onChange, error, disabled, icon, autoComplete, placeholder, readOnly, autoFocus }) {
  return (
    <div className="lp-field">
      <label className="lp-field-label" htmlFor={id}>{label}</label>
      <div className="lp-field-wrap">
        <input
          id={id}
          type="text"
          className={`lp-input${error ? " lp-input-err" : ""}`}
          value={value}
          placeholder={placeholder}
          onChange={(e) => onChange?.(e.target.value)}
          disabled={disabled}
          readOnly={readOnly}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          style={{ paddingRight: icon ? 36 : undefined, opacity: readOnly ? 0.75 : 1 }}
        />
        {icon && <i className={`fa-solid ${icon} lp-input-icon`} />}
      </div>
      {error && <FieldError msg={error} />}
    </div>
  );
}

export function FieldError({ msg }) {
  return (
    <div className="lp-ferr">
      <i className="fa-solid fa-circle-exclamation" style={{ fontSize: "0.62rem" }} />
      {msg}
    </div>
  );
}

/** Aplana la respuesta de error de DRF ({campo: [msg]}) a {campo: "msg"}. */
export function erroresDeCampo(data) {
  const out = {};
  Object.entries(data || {}).forEach(([k, v]) => {
    out[k] = Array.isArray(v) ? v.join(" ") : String(v);
  });
  return out;
}
